<template>
  <div class="page--permissions">
    <v-container fluid>
      <v-row>
        <v-col class="landing-page-edition" cols="12" md="5" lg="4" xl="3">
          <div class="sticky">
            <lp-editor
              :landing-page-data="previewData"
              @sections-updated="updateSections"
              @on-save="onSave"
            ></lp-editor>
          </div>
        </v-col>

        <v-col class="landing-page-preview" cols="12" md="7" lg="8" xl="9">
          <v-card rounded="lg" class="pa-5">
            <div>
              <landing-page
                :preview="true"
                :preview-data="previewData"
              ></landing-page>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Cover } from "components/landing-page/LandingPageCover";
import { Faq } from "components/landing-page/LandingPageFaq";
import { Section, Footer } from "components/landing-page/LandingPageSection";

import TipoSecaoEnum from "~/commons/enums/tipo-secao.enum";
import LandingPage from "views/pre-login/BaseLandingPage";
import LpEditor from "~/components/landing-page/editor/BaseLandingPageEditor";

export default {
  name: "ConfigureLandingPage",
  components: { LandingPage, LpEditor },
  data: () => ({
    previewData: {
      app: {
        name: "Nome do Sistema",
        alias: "Sigla",
      },
      sections: [],
      showTopbarColor: true,
    },
  }),
  beforeMount() {
    this.loadSections().then(() => {
      this.hidePageLoading();
    });
  },
  methods: {
    async obterImagem(section, atributo) {
      const { data } = await this.$obterImagem({ params: { path: section[atributo] }, responseType: "blob" });
      const getFileName = (filePath) => {
        return filePath.split('\\').pop();
      }
      section[atributo] = new File([data], getFileName(section[atributo]));
    },
    async obterImagensAoCarregar(sections) {
      for (let section of sections) {
        if (section.coverSrc) {
          await this.obterImagem(section, "coverSrc");
        }
        if (section.logoSrc) {
          await this.obterImagem(section, "logoSrc");
        }
      }
    },
    async obterItensDoFAQ() {
      const { data } = await this.$obterPerguntasFaq();
      return data.faq.map(item => ({
        id: item.id,
        title: item.pergunta,
        description: item.resposta,
        tokens: item.palavrasChave,
      }));
    },
    async loadSections() {
      return this.$obterConteudoSecoes().then(async ({ data }) => {
        this.previewData.sections.length = 0;
        const secoes = JSON.parse(data.json);
        await this.obterImagensAoCarregar(secoes);
        const items = await this.obterItensDoFAQ();
        secoes?.map((section) => {
          switch (section.tipo) {
            case TipoSecaoEnum.CAPA:
              return new Cover(section);
            case TipoSecaoEnum.FAQ:
              return new Faq({ ...section, items: items });
            case TipoSecaoEnum.RODAPE:
              return new Footer(section);
            case TipoSecaoEnum.SOBRE:
              return new Section(section);
          }
        }).forEach((section) => {
          this.previewData.sections.push(section);
        });
      });
    },
    updateSections(sections) {
      this.previewData.sections = sections;
    },
    async onSave(sections) {
      const has = (s, t) => [...t].includes(s.tipo) && (s.coverSrc || s.logoSrc || s.imageSrc);
      const json = sections.map(s => s.toApi());
      const salvarImagem = async (section) => {
        const formData = new FormData();
        formData.append(`TipoSecao`, section.tipo);
        formData.append(`Fundo`, section.coverSrc);
        formData.append(`Logotipo`, section.logoSrc || section.imageSrc);
        const { data } = await this.$salvarImagem(formData);
        return { ...section, coverSrc: data.enderecoDaImagem, logoSrc: data.enderecoDaImagemDeLogotipo };
      };
      const savedSections = await Promise.all(json.filter(s => has(s, [TipoSecaoEnum.CAPA, TipoSecaoEnum.SOBRE])).map(async s => salvarImagem(s)));
      const mappedJson = [...savedSections, ...json.filter(s => !has(s, [TipoSecaoEnum.CAPA, TipoSecaoEnum.SOBRE]))];
      this.$salvarConteudoSecoes({ json: JSON.stringify(mappedJson) }).then(({ data }) => {
        this.$notifySuccess(data.mensagem);
      }).catch(() => {
        this.$notifyError("Não conseguimos atualizar a página inicial.");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.thumbnail) {
  border: 1px solid #ddd;
  border-radius: 10cm;

  .v-image__image--cover {
    border: 5px solid #fff;
    border-radius: 10cm;
  }
}
.sticky {
  position: sticky;
  top: 75px;
}
</style>